import { render, staticRenderFns } from "./customers-by-program.vue?vue&type=template&id=7996c755&"
import script from "./customers-by-program.vue?vue&type=script&lang=ts&"
export * from "./customers-by-program.vue?vue&type=script&lang=ts&"
import style0 from "./customers-by-program.vue?vue&type=style&index=0&id=7996c755&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports